module.exports = {
    pluginOptions: {
      i18n: {
        locale: localStorage.getItem("locale") || 'en',
        fallbackLocale: 'en',
        localeDir: 'locales',
        enableInSFC: true
      }
    },
  }


//////////////////
// WEBPACK FOOTER
// ./vue.config.js
// module id = 2227
// module chunks = 0